import z, { ZodType } from 'zod';

export const deviceDeletedResponseSchema: ZodType<number> = z.number();
